import { writable, get } from 'svelte/store';
import * as util from '../js/util.js';
import { db } from "./db.js";
import { langTextStore } from "../store/langtexts.js";
import { validate_each_keys } from 'svelte/internal';

function createMyStore() {
    const { subscribe, set, update } = writable({ email: null, uuid: null, name: null, seenTour: false, langName: null, loginDetermined: false });

    return {
        subscribe, update, get,
        loginOffline: async (serveruser, create) => {
            if (!serveruser.userId)
                serveruser = { userId: serveruser };
            var userList = await db.users
                .where("uuid")
                .equals(serveruser.userId)
                .first(async (user) => {
                    if (user == undefined) {
                        if (create == false) {
                            localStorage.setItem('loggedInUser', null);
                            return;
                        }
                        user = { email: serveruser.email, uuid: serveruser.userId, seenTour: false };
                        await db.users.add(user);
                        update(n => { return user })
                        update(n => Object.assign(n, { loginDetermined: true }));

                        localStorage.setItem('loggedInUser', JSON.stringify(user));

                    } else {
                        update(n => { return user })
                        update(n => Object.assign(n, { loginDetermined: true }));


                        if (user.langName) {
                            langTextStore.setLang(user.lang)
                        }
                        localStorage.setItem('loggedInUser', JSON.stringify(user));
                    }
                })
        },
        login: async (email, password) => {
            try {
                var response = await fetch('/api/auth/login', {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email: email, password: password })
                });
                if (response.ok) {
                    var user = await response.json();
                    if (user && user.email.length > 0) {
                        update(n => Object.assign(n, { loginDetermined: true }));
                        loggedInUserStore.loginOffline(user, true)

                        return { success: true, errormessage: '' };
                    }
                    else {
                        update(n => Object.assign(n, { loginDetermined: false }));
                        return { success: false, errormessage: 'general-error-invalid-username-password' };

                    }
                }
                else {
                    alert('error3 ')
                    debugger;
                }
            }
            catch (e) {
                alert('Cant access server, but allowing you to access local data')
                //check localk
            }
            //if offline and  local allow to enter with only email?
            alert('cant login offline')
            //loggedInUserStore.loginOffline(email, false)

        },
        registerstep1: async (userDetails) => {
            try {
                var langName = get(langTextStore).langName
                var response = await fetch('/api/auth/registerstep1', {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email: userDetails.email, lang: langName, userId: util.generateUUID(), functionName: userDetails.functionName, country: userDetails.country, organizationType: userDetails.organizationType })
                });
                if (response.ok) {
                    var result = await response.json()
                    return { success: result.success, errormessage: result.errormessage }
                }
                else {
                    return { success: false, errormessage: 'bad http status' }
                }
            }
            catch (e) {
                return { success: false, errormessage: 'error in register' }
                alert('error ' + e)
                debugger;
                //check localk
            }
        },
        registerstep2: async (email, password, token) => {

            try {
                var response = await fetch('/api/auth/registerstep2', {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email: email, password: password, token: token })
                });
                if (response.ok) {
                    var result = await response.json()
                    if (result.success) {
                        await loggedInUserStore.login(email, password)
                        return { success: true, errormessage: '' };
                    }
                    return { success: result.success, errormessage: result.errormessage }
                }
                else {
                    return { success: false, errormessage: 'bad http status' }
                }
            }
            catch (e) {
                debugger;
                return { success: false, errormessage: 'error in register' }
                alert('error ' + e)
                //check localk
            }
        },
        forgotpasswordstep1: async (email) => {
            try {
                var langName = get(langTextStore).langName
                var response = await fetch('/api/auth/forgotpasswordstep1', {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email: email, lang: langName })
                });
                if (response.ok) {
                    var result = await response.json()
                    return { success: result.success, errormessage: result.errormessage }
                }
                else {
                    return { success: false, errormessage: 'bad http status' }
                }
            }
            catch (e) {
                return { success: false, errormessage: 'error in register' }
                alert('error ' + e)
                debugger;
                //check localk
            }
        },
        forgotpasswordstep2: async (email, password, token) => {

            try {
                var response = await fetch('/api/auth/forgotpasswordstep2', {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email: email, password: password, token: token })
                });

                if (response.ok) {
                    var result = await response.json()
                    if (result.success) {
                        loggedInUserStore.loginOffline(email, true)
                        return { success: true, errormessage: '' };
                    }
                    return { success: result.success, errormessage: result.errormessage }
                }
                else {
                    return { success: false, errormessage: 'bad http status' }
                }
            }
            catch (e) {
                return { success: false, errormessage: 'error in register' }
                alert('error ' + e)
                debugger;
                //check localk
            }
        },
        logout: () => {
            localStorage.removeItem('loggedInUser');
            window.setTimeout(() => {

                window.open("/", "_self");
            }, 500);
            update(n => { return { uuid: null, name: null, seenTour: false, loggedinOnline: false, loginDetermined: false, email: '' } });
        },
        seenTour: async () => {
            var user = get(loggedInUserStore)
            await db.users.update(user.uuid, { seenTour: true })
            update(n => Object.assign(n, { seenTour: true }));
        }
        ,
        seenTourNo: async () => {
            var user = get(loggedInUserStore)
            await db.users.update(user.uuid, { seenTour: false })
            update(n => Object.assign(n, { seenTour: false }));
        }
        ,
        setLang: async (lang) => {
            var user = get(loggedInUserStore)
            if (user && user.email && user.email.length > 0) {
                await db.users.update(user.uuid, { lang: lang })
            }
        },
        hideTour: async () => {
            update(n => Object.assign(n, { seenTour: true }));
        },
        setLoginNeeded: () => {
            update(n => Object.assign(n, { loginDetermined: false }));

        }


    };
}
export const loggedInUserStore = createMyStore();